import { el } from "../ui/dom.js";

/**
 * Global sign-in feed: an SSE stream (/api/presence) that stays open for the
 * whole session — menus, lobby, or match. Default display is a top-center
 * toast; MatchMode installs a handler to route events into the in-game chat
 * feed instead (like a T message).
 */

export interface PresenceEvent {
  username: string;
  guest?: boolean;
}

let handler: ((e: PresenceEvent) => void) | null = null;

/** MatchMode installs/clears this to show sign-ins in the chat log. */
export function setPresenceHandler(h: ((e: PresenceEvent) => void) | null): void {
  handler = h;
}

const toasts: HTMLElement[] = [];

function toast(text: string): void {
  const note = el("div", {
    style:
      "position:fixed;left:50%;transform:translateX(-50%);z-index:998;" +
      "background:#0a1a1e;border:1px solid #00f0ff55;color:#7ff3ff;" +
      "padding:6px 16px;font-size:12px;letter-spacing:0.12em;text-transform:uppercase;" +
      "text-shadow:0 0 6px #00f0ff66;pointer-events:none;transition:opacity 0.4s",
    text,
  });
  toasts.push(note);
  while (toasts.length > 3) toasts.shift()?.remove();
  toasts.forEach((t, i) => { t.style.top = `${14 + (toasts.length - 1 - i) * 34}px`; });
  document.body.append(note);
  setTimeout(() => { note.style.opacity = "0"; }, 3600);
  setTimeout(() => {
    note.remove();
    const i = toasts.indexOf(note);
    if (i >= 0) toasts.splice(i, 1);
  }, 4000);
}

let started = false;

/** Open the feed once at app boot. EventSource reconnects on its own. */
export function startPresence(): void {
  if (started) return;
  started = true;
  const es = new EventSource("/api/presence");
  es.onmessage = (ev) => {
    try {
      const e = JSON.parse(ev.data) as PresenceEvent;
      if (!e.username) return;
      if (handler) handler(e);
      else toast(`⚡ ${e.username} jacked in`);
    } catch {
      /* malformed event — ignore */
    }
  };
}
